import { Component, computed, inject } from '@angular/core';

import { Card, CardContainer, CardHeader, Page, PageHeader, InterpolatedTranslatePipe } from '@web/common';
import { Member, MemberStore } from '@web/service';

const KeyCustomFieldAopAok = ['aok-aop-obligatorisk', 'aok-aop-pbuekstra'];

@Component({
  selector: 'pbu-aop',
  template: `
    <cas-page>
      <cas-page-header
        header="cas.aopAokHeader"
        subheader="cas.aopAokSubheader" />
      @for (customField of customFields(); track customField.key) {
        <cas-card-container xxlCols="1">
          <cas-card>
            <cas-card-header [name]="customField.name"></cas-card-header>
            <dl class="row mb-0">
              @for (pair of customField.value; track pair.key) {
                <dt class="col-sm-5 text-muted fw-normal">{{ pair.key | translate }}</dt>
                <dd class="col-sm-7 fw-bold">{{ pair.value }}</dd>

                @if (!$last) {
                  <div class="col-12"><hr class="text-light" /></div>
                }
              }
            </dl>
          </cas-card>
        </cas-card-container>
      }
    </cas-page>
  `,
  standalone: true,
  imports: [Page, PageHeader, CardContainer, Card, InterpolatedTranslatePipe, CardHeader],
})
export class AopAokComponent {
  static isActive = ({ member }: { member?: Member }) => {
    return !!member?.customFields?.some(c => c.key && KeyCustomFieldAopAok.includes(c.key) && c.value?.length);
  };

  #memberStore = inject(MemberStore);

  protected customFields = computed(() => {
    if (!this.#memberStore.member.hasValue()) return undefined;
    const member = this.#memberStore.member.value();
    const customFields = member?.customFields?.filter(c => c.key && KeyCustomFieldAopAok.includes(c.key));
    if (!customFields?.length) return undefined;

    const toReturn = customFields.map(c => {
      return {
        key: c.key!,
        name: `cas.customField-${c.key}`,
        value:
          c.value?.flatMap(record =>
            Object.entries(record).map(([key, value]) => ({
              key,
              value: typeof value === 'object' ? JSON.stringify(value) : value,
            })),
          ) || [],
      };
    });
    return toReturn;
  });
}
